export default class AbstractCanopyStyle {
    _points = null;

    constructor(ellipse) {
        this.ellipse = ellipse;
    }

    get p() { return this.ellipse.p; }
    get view() { return this.ellipse.view; }

    // Ensures points are generated, setting up seeds beforehand.
    // Call this from display() and getMiniView() in subclasses that need points.
    ensurePoints() {
        if (this._points) return;
        if (!this.ellipse.canopySeed) {
            this.ellipse.canopySeed = Math.floor(Math.random() * 100000);
        }
        this.p.noiseSeed(this.ellipse.canopySeed);
        this.p.randomSeed(this.ellipse.canopySeed);
        this._points = this.generatePoints();
    }

    clearPoints() {
        this._points = null;
    }

    // Override in subclasses that need procedural points.
    generatePoints() {
        return null;
    }

    // Multiplier applied to absSize + strokeWidth to get the full bounding box size.
    // Override in styles where rendering extends beyond the circumference.
    get absMaxSizeMultiplier() {
        return 1;
    }

    // Subclasses must implement:

    // Renders the canopy shape onto g. appearance.apply() has already been called.
    display(g, opacity) {
        throw new Error(`${this.constructor.name} must implement display()`);
    }

    // Returns the mini-view representation. size is the pre-mapped display size.
    getMiniView(size) {
        throw new Error(`${this.constructor.name} must implement getMiniView()`);
    }
}
